/* global sgData, $, shopSettings, sgEnv */
/**
 * Responsible for sending logs to api endpoint
 */
class WebLogger {
  /**
   *
   * @return {{LEVEL_INFO: string, LEVEL_ERROR: string, LEVEL_DEBUG: string}}
   */
  static get constants() {
    return {
      LEVEL_INFO: 'i',
      LEVEL_ERROR: 'e',
      LEVEL_DEBUG: 'd',
    };
  }

  static getEnvironmentData() {
    if (typeof sgData === 'undefined') {
      return {};
    }
    return {
      envShop: sgData.shop,
      envDevice: sgData.device,
      envPage: sgData.page,
    };
  }

  static isWebLogEnabled() {
    if (typeof shopSettings === 'undefined') {
      return false;
    }

    return !!shopSettings.hasWebLogging;
  }

  constructor() {
    this.envData = this.constructor.getEnvironmentData();
    this.enabled = this.constructor.isWebLogEnabled();
    this.endpointUrl = `${sgEnv.apiUrl}/weblog`;
  }

  /**
   * Sends log to api
   * @param {string} level logLeel
   * @param {Object} data data to send
   */
  sendLog(level, data) {
    if (!this.enabled) {
      return;
    }
    this.checkEnvData();
    const payload = $.extend({}, data, this.envData);
    $.ajax({
      url: `${this.endpointUrl}/${level}`,
      type: 'POST',
      dataType: 'json',
      data: payload,
      crossDomain: true,
    });
  }

  checkEnvData() {
    const dataLength = Object.keys(this.envData).length;
    if (dataLength > 0) {
      return;
    }
    this.envData = this.constructor.getEnvironmentData();
  }
}

export default WebLogger;



// WEBPACK FOOTER //
// ./Library/1.0/common/web-logging/web-logger.js